'use client';

interface ShapesProps {
	shape: 'rectangle' | 'ellipse-left' | 'ellipse-right' | 'right-blob' | 'corner-blob' | 'circle';
	className?: string;
	width?: string; // Optional width prop
	height?: string; // Optional height prop
}

export function Shapes({ shape, className }: ShapesProps) {
	switch (shape) {
		case 'circle':
			return (
				<svg
					className={className}
					viewBox="0 0 59 61"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<ellipse cx="29.5" cy="30.5" rx="29.5" ry="30.5" fill="#4280FF" />
				</svg>
			);

		case 'rectangle':
			return (
				<svg
					className={className}
					viewBox="0 0 1169 1377"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<mask
						id="mask0_4556_500"
						style={{ maskType: 'alpha' }}
						maskUnits="userSpaceOnUse"
						x="124"
						y="240"
						width="1609"
						height="1405"
					>
						<path
							d="M160.272 985.699C106.553 922.359 114.526 827.426 178.057 773.934L769.781 275.708C822.307 231.482 898.157 228.568 953.92 268.635L1670.08 783.207C1752.56 842.468 1753.54 964.842 1672.02 1025.42L878.274 1615.28C814.785 1662.46 725.57 1652.24 674.407 1591.91L160.272 985.699Z"
							fill="#4280FF"
						/>
					</mask>
					<g mask="url(#mask0_4556_500)">
						<rect x="-559" y="229.003" width="1728" height="780" fill="#4280FF" />
					</g>
				</svg>
			);
		case 'ellipse-left':
			return (
				<svg
					className={className}
					viewBox="0 0 280 410"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M244.446 204.844C244.446 298.585 168.296 374.688 74.2231 374.688C-19.8496 374.688 -96 298.585 -96 204.844C-96 111.103 -19.8496 35 74.2231 35C168.296 35 244.446 111.103 244.446 204.844Z"
						stroke="#4280FF"
						strokeWidth="70"
					/>
				</svg>
			);
		case 'ellipse-right':
			return (
				<svg
					className={className}
					viewBox="0 0 348 410"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M375.446 204.844C375.446 298.585 299.296 374.688 205.223 374.688C111.15 374.688 35 298.585 35 204.844C35 111.103 111.15 35 205.223 35C299.296 35 375.446 111.103 375.446 204.844Z"
						stroke="#4280FF"
						strokeWidth="70"
					/>
				</svg>
			);
		case 'right-blob':
			return (
				<svg
					className={className}
					viewBox="0 0 191 646"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M36.376 406.096C-17.3431 342.757 -9.37028 247.824 54.1607 194.331L242.159 36.0386C294.685 -8.1877 370.535 -11.101 426.298 28.9659L646.706 187.332C729.182 246.593 730.164 368.967 648.649 429.543L398.173 615.682C334.684 662.863 245.468 652.634 194.305 592.308L36.376 406.096Z"
						fill="#4280FF"
					/>
				</svg>
			);
		case 'corner-blob':
			return (
				<svg
					className={className}
					viewBox="0 0 157 646"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M-516.624 406.096C-570.343 342.757 -562.37 247.824 -498.839 194.331L-310.841 36.0386C-258.315 -8.1877 -182.465 -11.101 -126.702 28.9659L93.7056 187.332C176.182 246.593 177.164 368.967 95.6493 429.543L-154.827 615.682C-218.316 662.863 -307.532 652.634 -358.695 592.308L-516.624 406.096Z"
						fill="#4280FF"
					/>
				</svg>
			);
	}
}
